var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"text-uppercase white--text",attrs:{"color":_vm.color,"label":"","small":""}},[_vm._v(" "+_vm._s(_vm.parcela.situacaoEmExtenso)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }